(function($) {    
    $.fn.mySlider = function(options) {
        var methods = {
            setBorders: function(width,height) {
                
                
            },
            destroy: function() {   
                var th=$(this);
                th.html("");
                th.data("mySlider",null);
            },
            update: function(min,max,val){
                var th=$(this), set=th.data("mySlider");
                set.min=min;
                set.max=max;
                th.data("mySlider",set);
                if(typeof val=="undefined" || val===null){
                    val=intval(th.attr("value"));
                }
                val=Math.max(min,val);
                val=Math.min(max,val);
                setValue(val,this);
            },
            setMax:function(){
                var th=$(this), set=th.data("mySlider");
                setValue(intval(set.max),this);
            },
            setValue:function(value){
                setValue(value, this);
            }
            
        };
        function move(e,main){	
            /*if(!main.is(".mySlider")){
                main=main.closest(".mySlider");
            }*/
            var set=main.data("mySlider");
            if(typeof set.vertical=="undefined"){
                return false;
            }
            var obj=main.find(".myHandler");
			var handle_width=intval(obj.css('width')),width=intval(main.css('width'));
            if(set.vertical){
                handle_width=intval(obj.css('height'));
                width=intval(main.css('height'));
            }
			var min=-handle_width/2,
			max=width-handle_width/2,left,step,val,offs;
            
            if(set.max>set.min){
                step=(width)/(set.max-set.min);	
                if(set.vertical){
                    offs=intval(main.offset().top)+(handle_width/2);
                    left=$.getYevent(e)-offs;
                }
                else{
                    offs=intval(main.offset().left)+(handle_width/2);
                    left=$.getXevent(e)-offs;
                }
                left=Math.floor(left/step)*step;
                if(left<min){
                    left=min;
                }
                if(left>max){
                    left=max;
                }
                val=Math.floor((left+handle_width/2)/(width)*(set.max-set.min))+set.min;
            }
            else{
                left=max;
                val=set.min;
            }
			
            
						
			
            if(set.vertical){
                obj.css('top',left+'px');
                val=set.max-val+set.min;
            }
            else{
                obj.css('left',left+'px');
            }
            main.attr("value",val);
            main.find("[type='hidden']").attr('value',val);
            setFill(main,left,handle_width,set.vertical,width);
            main.trigger("change",val);
            return false;
		}
        function setValue(val,main){
            var set=main.data("mySlider");
            var obj=main.find(".myHandler");
			var handle_width=intval(obj.css('width')),width=intval(main.css('width'));
            if(set.vertical){
                handle_width=intval(obj.css('height'));
                width=intval(main.css('height'));
            }
            //step=(max-min+handle_width)/(set.max-set.min),
			var min=-handle_width/2,
			max=width-handle_width/2,left,step;
            val=intval(val);
            val=Math.max(val,set.min);
            val=Math.min(val,set.max);
            if(set.max>set.min){
                step=(width)/(set.max-set.min),			
                left=(val-set.min)*(max+handle_width)/(set.max-set.min)-handle_width/2;
                left=Math.floor(left/step)*step;

                if(left<min){
                    left=min;
                }
                if(left>max){
                    left=max;
                } 
            }
            else{
                left=max;
            }
                
                
                
                
            
            
            
			main.attr("value",val);
            main.find("[type='hidden']").attr('value',val);
            if(set.vertical){
                 left=max-(left+handle_width/2);
                 if(left<min){
                    left=min;
                }
                if(left>max){
                    left=max;
                } 
                 obj.css('top',left+'px');
            }
            else{
                 obj.css('left',left+'px');
            }
            setFill(main,left,handle_width,set.vertical,width);
            main.trigger("change",val);
            
        }
        function setFill(main,left,handle_width,vertical,width_max){
            var width=left+handle_width/2;
            if(!vertical){
                main.find(".fill").width(width);
            }
            else{
                main.find(".fill").height(width_max-width);
            }
        }
        function prepareSlider(obj){
            var set=obj.data("mySlider");
            var html="<div class='allfill'><div class='fill'></div></div><div class='myHandler'></div>";
            if(obj.attr("name")){
                html+="<input type='hidden' name='"+obj.attr("name")+"'>";
            }    
            obj.append(html);
            if(set.value){
                setValue(intval(set.value), obj);
            }
            else{
                setValue(intval(set.min), obj);
            }
            
            obj.on("mousedown touchstart",function(e){
                move(e,obj);
                $("body").on("mousemove touchmove",epos).on("mouseup touchend",epos2);
                return false;
            }).on("mouseup",epos2);
            function epos(e){
                move(e,obj)
            }
            function epos2(){
                $('body').off('mousemove touchmove',epos).off("mouseup touchend",epos2);
            }
        } 
        var last_this=this; 
        var arg =Array.prototype.slice.call(arguments,1);
        return this.each(function() {            
            if(methods[options]){  
                return methods[options].apply(last_this,arg);
            }
            else if (typeof options === 'object' || !options){ 
                var $this = $(this),
                data = $this.data("mySlider");  
                
                if(!data){    
                    
                    var settings = $.extend( {
                        min : 0,
                        max:    20,
                        onStep:1,
                        vertical:0
                    }, options);                    
                    data = $this.data("mySlider", settings);
                    var addclass="mySlider";
                    if(settings.vertical){
                        addclass+=" vertical";
                    }
                    $this.addClass(addclass);
                    prepareSlider($this); 
                    var cur=intval(settings.cur);
                    if(!cur){
                        cur=intval($this.attr("cur"));
                    }
                    if(cur){
                        setValue(cur, $this);
                    }
                }                
                data.first = true;
                return;
            }
            else{
                if(typeof methods[options]=="function"){
                    return methods[options].apply(last_this,arg);
                }
                else{
                   $.error('mySlider: no method: '+ options); 
                }
                
            }
        });
    }
})(jQuery); 